// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"fa5568af","213":"1cede0d9","239":"803e667d","453":"b62dcd8f","667":"35242db6"}[chunkId] + ".chunk.js";
};